/**
 * @generated SignedSource<<ab1c2c9ad603ce07e3a7949a8d210f73>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type templateGuideContentfulRelayFragment$data = {
  readonly templateGuideNameExternal: string | null | undefined;
  readonly templateStepsCollection: {
    readonly items: ReadonlyArray<{
      readonly stepAsset: {
        readonly url: string | null | undefined;
      } | null | undefined;
      readonly stepDescription: {
        readonly json: any;
      } | null | undefined;
      readonly stepNameExternal: string | null | undefined;
    } | null | undefined>;
  } | null | undefined;
  readonly " $fragmentType": "templateGuideContentfulRelayFragment";
};
export type templateGuideContentfulRelayFragment$key = {
  readonly " $data"?: templateGuideContentfulRelayFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"templateGuideContentfulRelayFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "templateGuideContentfulRelayFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "templateGuideNameExternal",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TemplateGuideTemplateStepsCollection",
      "kind": "LinkedField",
      "name": "templateStepsCollection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TemplateUseStep",
          "kind": "LinkedField",
          "name": "items",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "stepNameExternal",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "TemplateUseStepStepDescription",
              "kind": "LinkedField",
              "name": "stepDescription",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "json",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Asset",
              "kind": "LinkedField",
              "name": "stepAsset",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "url",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TemplateGuide",
  "abstractKey": null
};

(node as any).hash = "0e73fcc9a5b16d949c71909fe7de9c38";

export default node;
